import React, { useState, useEffect, useRef } from 'react';

const PRINCIPLES = [
    'The Given Set',
    'Parent',
    'Our Parent',
    'Operating Principle',
    'Main Set',
    'Mother Nature',
    'Show Actual Principle',
    'Show Derived Principle'
];

export default function WizardSelectPrincipleForm({ onDataChange, initialData }) {
    const [selectedPrinciple, setSelectedPrinciple] = useState(initialData.selectedPrinciple || '');
    const onDataChangeRef = useRef(onDataChange);

    // Update ref when callback changes
    useEffect(() => {
        onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    // Only call onDataChange when actual data changes, not when callback changes
    useEffect(() => {
        if (onDataChangeRef.current) {
            onDataChangeRef.current({ selectedPrinciple });
        }
    }, [selectedPrinciple]);

    const handlePrincipleChange = (principle) => {
        setSelectedPrinciple(principle);
    };

    return (
        <div className="wizard-select-principle-form">
            <h2 className="wizard-step-heading">Select Principle</h2>
            <div className="principle-list">
                {PRINCIPLES.map((principle, index) => (
                    <div
                        key={index}
                        className={`principle-option ${selectedPrinciple === principle ? 'selected' : ''}`}
                        onClick={() => handlePrincipleChange(principle)}
                    >
                        <div className="principle-option-content">
                            <span className="principle-label">{principle}</span>
                            <input
                                type="radio"
                                name="principle"
                                value={principle}
                                checked={selectedPrinciple === principle}
                                onChange={() => handlePrincipleChange(principle)}
                                className="principle-radio"
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
